import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

const UITableToolbar = ({ header, controls, activeFilters, children, sx, className }) => {
  return (
    <Box
      className={className}
      sx={{
        px: 2.5,
        py: 1.75,
        backgroundColor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "divider",
        flexShrink: 0,
        ...sx,
      }}
    >
      {children ? (
        children
      ) : (
        <>
          {header}
          {header && controls ? <Divider sx={{ mt: 1.75, mb: 0 }} /> : null}
          {controls ? <Box sx={{ mt: header ? 1.75 : 0 }}>{controls}</Box> : null}
          {activeFilters ? <Box sx={{ mt: 1.25 }}>{activeFilters}</Box> : null}
        </>
      )}
    </Box>
  );
};

export default UITableToolbar;
